module.exports = "/_next/static/images/game-1-phone-background-99ef289d6eb0f128ce19a8915fa079f3.jpg";